import moment from "moment";

export enum MedicationStopTypeEnum {
  TEMPORARY,
  DEFINITIVE
}

export enum MedicationStopReasonEnum {
  ALLERGY,
  INTOLERANCE,
  PATHOLOGY_CHANGE,
  OTHER
}

export interface MedicationStopType {
  readonly type: MedicationStopTypeEnum;
  readonly startDate: Date;
  readonly reasonType: MedicationStopReasonEnum;
}

export class MedicationStop implements MedicationStopType {
  readonly type: MedicationStopTypeEnum;
  readonly startDate: Date;
  readonly reasonType: MedicationStopReasonEnum;

  constructor(data?: MedicationStopType) {
    this.type = MedicationStopTypeEnum.DEFINITIVE;
    this.startDate = moment().toDate();
    this.reasonType = MedicationStopReasonEnum.OTHER;
    data && Object.assign(this, data);
  }
}
